import React, { useState } from 'react'

export default function PriceHeader({ handler, setCategory, category }) {
    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
        handler(e.target.checked)
    };
    const onChangeCategory = (e) => {
        const { id } = e.target
        setCategory(id)
    }
    return (
        <div className="row px-0">
            <div className="col-sm-10 m-b-xs">
                <div data-toggle="buttons" className="btn-group btn-group-toggle">
                    <label className="btn btn-sm btn-white">
                        <input
                            type="radio"
                            id="Lunch"
                            checked={category === "Lunch"}
                            name="category"
                            onChange={(e) => onChangeCategory(e)}
                        />
                        Lunch
                    </label>
                    <label className="btn btn-sm btn-white">
                        <input
                            type="radio"
                            id="Dinner"
                            checked={category === "Dinner"}
                            name="category"
                            onChange={(e) => onChangeCategory(e)}
                        /> Dinner
                    </label>
                </div>
            </div>
            <div className="col-sm-2">
                <div className='d-flex align-items-baseline' >
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => handleCheckboxChange(e)}
                        id="checkbox1" />
                    <label htmlFor='checkbox1'>  Provide Delivery</label>
                </div>
            </div>
        </div>
    )
}
